<template>
  <PVConfirmDialog
    :blockScroll="true"
    :dismissableMask="true"
    :draggable="false"
    v-bind="$attrs"
    :closable="false"
  />
</template>

<script setup lang="ts">
import PVConfirmDialog from 'primevue/confirmdialog';
</script>

<script lang="ts">
export default {
  name: 'ConfirmDialog',
  inheritAttrs: false,
};
</script>
